import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";

import { CommonService } from "../../services/common.service";

@Component({
  standalone: false,
  selector: "app-home",
  templateUrl: "./home.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./home.component.scss"]
})
export class HomeComponent implements OnInit {
  constructor(private router: Router, private commonService: CommonService) { }
  disableMenu: boolean;

  ngOnInit(): void { }

  onOutletLoaded(component: any) {
    this.commonService.disableHeader.next(this.router.url);
  }
}
